module.exports = __webpack_public_path__ + "static/media/tech-video-1.e0df3d12.png";